import ImagePreview from 'components/atoms/ImagePreview'
import PdfPreview from 'components/atoms/PdfPreview'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useWizard } from 'react-use-wizard'
import { getFileNameExtension } from 'share/utils/fileUtils'
import { DocumentAddStep } from '../model'

interface StepViewFileProps {
  file?: File
}

type base64Type = string | ArrayBuffer | null

const StepViewFile = ({ file }: StepViewFileProps): JSX.Element => {
  const [base64Data, setBase64Data] = useState<base64Type>(null)
  const { previousStep } = useWizard()

  if (!file) {
    return (
      <React.Fragment>
        <h2>The file cannot be empty</h2>
      </React.Fragment>
    )
  }

  const [filename, extension] = getFileNameExtension(file?.name)

  const renderViewer = (): JSX.Element => {
    switch (extension) {
      case 'png':
      case 'bmp':
      case 'gif':
      case 'jpg':
      case 'jpeg':
        return renderImageViewer()
      case 'pdf':
        return renderPDFViewer()
      default:
        return <h2>Not supported file: {extension}</h2>
    }
  }

  const renderImageViewer = (): JSX.Element => {
    const fileReader = new FileReader()
    fileReader.onload = function (fileLoadedEvent) {
      const binaryData = fileLoadedEvent.target
        ? fileLoadedEvent.target.result
        : ''

      setBase64Data(binaryData)
    }
    fileReader.readAsDataURL(file)
    return <ImagePreview base64Image={base64Data as string} />
  }

  const renderPDFViewer = (): JSX.Element => {
    return <PdfPreview file={file} />
  }

  return (
    <React.Fragment>
      <h2>{filename}</h2>
      {renderViewer()}
      <div className='modal-footer modal-footer-custom mt-3'>
        <Button
          className='footer-btn btn-custom-secondary'
          variant='outline-secondary'
          onClick={() => previousStep(DocumentAddStep.SubmitFiles)}
        >
          Go Back
        </Button>
      </div>
    </React.Fragment>
  )
}

export default StepViewFile
